import { Attributes } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { ItemDelegate } from '@leverege/molten-core';
const EMPTY_OBJ = {};
export default function useDeviceSelector(props) {
  const {
    groupDelegate,
    nameAttribute: pNameAttribute = 'name',
    searchFields,
    value,
    onChange: pOnChange,
    eventData,
    getFilters
  } = props;
  const {
    relationship
  } = groupDelegate || EMPTY_OBJ;
  const [opened, setOpened] = useState();
  const [search, setSearch] = useState();
  const inputRef = useRef();
  const debounce = useRef();
  const nameAttribute = useMemo(() => {
    return Attributes.getAttribute(pNameAttribute || 'name', relationship?.objectType);
  }, [pNameAttribute, relationship]);
  const onChange = useCallback(evt => {
    pOnChange(evt);
    setOpened(false);
    setSearch(null);
  }, [pOnChange]);
  const onChangeFilter = useCallback(({
    value
  }) => {
    setSearch(value);
    clearTimeout(debounce.current);
    if (value && value.length > 1) {
      debounce.current = setTimeout(() => {
        let filter = {
          type: 'groupedText',
          value: `*${value}*`
        };
        if (searchFields) {
          filter.fields = searchFields.map(field => {
            return {
              field,
              type: 'interfixFinalToken'
            };
          });
        }
        if (typeof getFilters === 'function') {
          const addFilters = getFilters(value);
          if (Array.isArray(addFilters)) {
            filter = {
              type: 'logical',
              operator: 'and',
              conditions: [filter, ...addFilters]
            };
          } else if (addFilters) {
            filter = {
              type: 'logical',
              operator: 'and',
              conditions: [filter, addFilters]
            };
          }
        }
        if (groupDelegate) {
          GlobalState.dispatch(groupDelegate.search({
            filter
          }));
        }
      }, 500);
    }
  }, [groupDelegate, searchFields, getFilters]);
  useEffect(() => {
    const item = ItemDelegate.getItem(value);
    const searchVal = search || nameAttribute.get(item);
    onChangeFilter({
      value: searchVal
    });
  }, [search, opened, onChangeFilter]);
  const getContext = useCallback(() => {
    return {
      isScannable: true,
      search,
      onSearchChange: ({
        value
      }) => {
        setSearch(value);
        setOpened(true);
      },
      onClear: () => {
        setSearch('');
        inputRef.current?.focus();
      },
      value,
      onChange,
      eventData,
      clientProps: {
        objectType: relationship?.objectType
      }
    };
  }, [search, value, onChange, eventData, relationship?.objectType]);
  return {
    getContext,
    inputRef,
    nameAttribute,
    opened,
    search,
    setOpened,
    setSearch,
    onChange
  };
}